import { mapGetters } from 'vuex'
import _ from 'lodash'
import ModalMixin from '@/mixins/ModalMixin.js'

export default {
  name: 'DeliveryRequest',
  mixins: [ModalMixin],
  props: {
    delivery: Object
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    }),
    isDelivered() {
      return ['completed', 'not_collected'].includes(this.delivery.status)
    }
  },
  methods: {
    openLocker() {
      this.openCloseLockerPromptModal(
        this.$t('deliveryRequest.OPEN_LOCKER_MESSAGE'),
        () => {
          this.$emit('open-locker', {
            boxId: this.delivery.boxId,
            deliveryId: this.delivery.id,
            status: this.delivery.status
          })
        },
        this.$t('yes'),
        this.$t('cancel')
      )
    }
  }
}
